import "./weather.css";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Weather from "./weather/Weather";


const weatherwidgets = (props) => {
  const { t } = useTranslation();
  const { id } = useParams();

  return (
    <>

      <section className="single-banner">
        <div className="container__">
          <div className="row">
            <div className="col-lg-12">
              <div className="single-content">
                <h2>{t("weather")}</h2>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">{t("Home")}</Link>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="weatherContainer">
        <div className="WeatherWidgetContainer">
          <Weather t={t} id={id} />
        </div>
      </div>
    </>
  );
};

export default weatherwidgets;
